import Configuration from './configuration';

let firebase;
if (window.IDBIndex) {
  firebase = require("firebase/app"); // eslint-disable-line
}

// import * as firebase from 'firebase/app';
// import 'firebase/analytics';

const FIREBASE_KEY = Configuration.value('VUE_APP_FIREBASE_KEY');
const GCP_STORAGE_BUCKET = Configuration.value('VUE_APP_GCP_STORAGE_BUCKET');

const firebaseConfig = {
  apiKey: FIREBASE_KEY,
  authDomain: 'focus-healer-175515.firebaseapp.com',
  projectId: 'focus-healer-175515',
  storageBucket: GCP_STORAGE_BUCKET,
  messagingSenderId: '1086996803216',
  appId: '1:1086996803216:web:c176a3a5b9998ff3967215',
  measurementId: 'G-PX9ZNPXSTY',
};

const lazy = (fn) => {
  let isLoaded = false;
  let result;
  return () => {
    if (!firebase) return false;
    if (!isLoaded) {
      isLoaded = true;
      result = fn();
    }
    return result;
  };
};

const firebaseApp = lazy(() => {
  return firebase.initializeApp(firebaseConfig);
});
// const auth = lazy(() => firebaseApp().auth());
// const GoogleAuthProvider = lazy(() => new firebase.auth.GoogleAuthProvider());

export {
  firebaseApp,
  // auth,
  // GoogleAuthProvider
};
